import React from 'react';
import MigrationList from './MigrationList';
export default function MigrationActions() {
    return <MigrationList url={'action'} keyLabel="name" />
};